import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from './pages/login/index';
import Painel from './pages/painel/index';
import RedefinirSenha from './pages/redefinirsenha';
import EsqueciSenha from './pages/esquecisenha';
import Policy from './pages/policy/index';
import Acompanhamento from './pages/painel/acompanhamento';

import New_Cliente from './pages/clientes/new';
import List_Cliente from './pages/clientes/index';
import Edit_Cliente from './pages/clientes/edit';

import New_Produto from './pages/produtos/new';
import List_Produto from './pages/produtos/index';
import Edit_Produto from './pages/produtos/edit';

import List_Integracao from './pages/integracao/index';

import Edit_Topico from './pages/produtos/topicoEdit';
import Edit_SubTopico from './pages/produtos/subtopicoEdit';

import New_Usuario from './pages/usuarios/new';
import List_Usuario from './pages/usuarios/index';
import Edit_Usuario from './pages/usuarios/edit';

import Visao_Usuario_Produto from './pages/visaousuario/index';

import Avaliacao from './pages/avaliacao/edit';
import List_Pedidos from './pages/pedidos/index';
import Show_Pedido from './pages/pedidos/show';

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Login}/>
                <Route path="/login" component={Login} />
                <Route path="/painel" component={Painel}/>
                <Route path="/redefinirsenha" component={RedefinirSenha}/>
                <Route path="/esquecisenha" component={EsqueciSenha}/>
                <Route path="/politica" component={Policy}/>  
                <Route path="/treinamento/:id" component={Visao_Usuario_Produto}/>
                <Route path="/acompanhamento" component={Acompanhamento}/>
                <Route path="/avaliacao/:id" component={Avaliacao}/>

                <Route path="/cliente/novo" component={New_Cliente}/>
                <Route path="/clientes" component={List_Cliente}/>
                <Route path="/cliente/:id" component={Edit_Cliente}/>

                <Route path="/produto/novo" component={New_Produto}/>
                <Route path="/produtos" component={List_Produto}/>
                <Route path="/produto/:id" component={Edit_Produto}/>

                <Route path="/integracoes" component={List_Integracao}/>

                <Route path="/topico/:id" component={Edit_Topico}/>
                <Route path="/subtopico/:id" component={Edit_SubTopico}/>

                <Route path="/usuario/novo" component={New_Usuario}/>
                <Route path="/usuarios" component={List_Usuario}/>
                <Route path="/usuario/:id" component={Edit_Usuario}/>

                <Route path="/pedidos" component={List_Pedidos}/>
                <Route path="/pedido/:id" component={Show_Pedido}/>

            </Switch>
        </BrowserRouter>
    )
}